import axiosClient from "../axios/axiosClient";

export function getProgramLevels() {
  return axiosClient.get("/academic-program-levels");
}

export function getProgramLevel(programLevelId) {
  return axiosClient.get(`/academic-program-levels/${programLevelId}`);
}

export function createProgramLevel(data) {
  return axiosClient.post("/academic-program-levels", data);
}

export const updateProgramLevel = (programLevelId, data) => {
  return axiosClient.put(`/academic-program-levels/${programLevelId}`, data);
};

export function deleteProgramLevel(programLevelId) {
  return axiosClient.delete(`/academic-program-levels/${programLevelId}`);
}
